import type { FilterDef } from "../filters";

/** A chip's words: "Scope: 2", "Site: Depot, Hub", "Site: Depot +2". */
export function chipText(def: FilterDef, values: readonly string[]): string {
  const label = (value: string) => def.options.find((o) => o.value === value)?.label ?? value;
  const shown = values.slice(0, 2).map(label).join(", ");
  return `${def.label}: ${shown}${values.length > 2 ? ` +${String(values.length - 2)}` : ""}`;
}

